export function downloadApk() {
  // Served via backend API so the correct MIME type header is set,
  // preventing browsers from saving the file as .zip
  const link = document.createElement('a');
  link.href = 'https://api.golden777.fun/api/download/apk';
  link.download = 'golden777_app.apk';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
